export default "__VITE_ASSET__MF6C7QuFuFy3IL8iZK9YWA__ 480w, __VITE_ASSET__fcn1zEYvoumSGXGdCf_71g__ 745w";